import { enabledQuests } from './enabledQuests'
import type { QuestDoc } from './schemas'

// Returns the enabled quests that should participate in the scenario. When
// the scenario doesn't include quests, returns [] regardless of any cached
// `listQuests` from a prior enabled run — otherwise tunings from previously
// enabled quests would silently leak into base-submission records.
const scenarioActiveQuests = (
  scenarioIncludesQuests: boolean,
  listQuests: readonly QuestDoc[] | undefined
): readonly QuestDoc[] =>
  scenarioIncludesQuests ? enabledQuests(listQuests ?? []) : []

export default scenarioActiveQuests
